import { SecureStorageKeys } from "constants/secureStorage";
import { createContext, ReactNode, useEffect, useMemo, useState } from "react";
import type { Socket } from "socket.io-client";
import { disconnectSocket, initChatSocket } from "utils/chatSocket";
import { secureStorage } from "utils/secureStorage";

type ChatSocketContextValue = {
  socket: Socket | null;
  isConnected: boolean;
};

export const ChatSocketContext = createContext<ChatSocketContextValue>({
  socket: null,
  isConnected: false,
});

export function ChatSocketProvider({ children }: { children: ReactNode }) {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const token = secureStorage.get(SecureStorageKeys.CUSTOM_TOKEN);
    if (!token) {
      console.warn("chat socket missing auth token");
      return;
    }

    const s = initChatSocket(token);

    const handleConnect = () => setIsConnected(true);
    const handleDisconnect = () => setIsConnected(false);

    s.on("connect", handleConnect);
    s.on("disconnect", handleDisconnect);

    setSocket(s);

    return () => {
      s.off("connect", handleConnect);
      s.off("disconnect", handleDisconnect);
      disconnectSocket();
    };
  }, []);

  const value = useMemo(() => ({ socket, isConnected }), [socket, isConnected]);

  return (
    <ChatSocketContext.Provider value={value}>
      {children}
    </ChatSocketContext.Provider>
  );
}
